import { axiosInstanceIntegraciones, axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { ITenant } from '../../AbmLocalPage/types'
import { GetCodigoTienda, TiendaNames } from '../types'
import { CategoryWooResponse } from '../types/responses'
import { IProductoTienda, ProductosAA1TResponse, ProductosWooResponse } from '../types/responses-productos'

export const GetProductosAA1T = async (codLocal: string) =>
  (await axiosInstanceMain.get(`/avellaneda/productos/local/${codLocal}`)) as ProductosAA1TResponse

export const GetProductosTienda = async (
  tenant: string,
  tienda: TiendaNames,
  codLocal: string,
  idCategoria: string | number,
  searchText: string,
  sku: string,
  page = 1,
  perPage = 50
) => {
  let url = `/${tenant}/locales/${codLocal}/catalogo/productos?codigoTienda=${GetCodigoTienda(tienda)}&page=${page}&perPage=${perPage}`
  if (idCategoria) url += `&idCategoria=${idCategoria}`
  if (searchText) url += `&searchText=${searchText}`
  if (sku) url += `&sku=${sku}`
  return (await axiosInstanceIntegraciones.get(url)) as ProductosWooResponse
}

export const GetCategoriasTienda = async (tenant: string, tienda: TiendaNames, codLocal: string, noCache = false) =>
  (await axiosInstanceIntegraciones.get(
    `/${tenant}/locales/${codLocal}/catalogo/categorias?codigoTienda=${GetCodigoTienda(tienda)}${noCache ? '&noCache=true' : ''}`
  )) as CategoryWooResponse

export const SaveProductosAA1T = async (
  tienda: TiendaNames,
  codLocal: string,
  productos: IProductoTienda[],
  tenant: ITenant
) =>
  await axiosInstanceIntegraciones.post(
    `/${tenant.path}/locales/${codLocal}/productos?codigoTienda=${GetCodigoTienda(tienda)}`,
    productos
  )
